import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AssetsState {
    homeDetails: {
        homeLoanAmount: string;
        homeMonthlyPayment: string;
        homeInterestRate: string;
    };
}

const initialState: AssetsState = {
    homeDetails: {
        homeLoanAmount: "",
        homeMonthlyPayment: "",
        homeInterestRate: ""
    }
};

const assetsSlice = createSlice({
    name: "assets",
    initialState,
    reducers: {
        setHomeDetails: (state, action: PayloadAction<AssetsState["homeDetails"]>) => {
            state.homeDetails = action.payload;
        }
    }
});

export const { setHomeDetails } = assetsSlice.actions;
export default assetsSlice.reducer;
